import { Label } from "@mui/icons-material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import ReactSelect from "react-select";
import DeleteIcon from "@mui/icons-material/Delete";
import toast from "react-hot-toast";
import Tooltip from "components/Tooltip/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import { RemoveRedEye } from "@mui/icons-material";
import useDebounce from "hooks/useDebounce";

import EditIcon from "@mui/icons-material/Edit";
import {
  getCityWiseSections,
  getCityDropdown,
  cityWiseSectionDisplayOrder,
  cityWiseSectionDelete,
} from "services/citypages";
import UpdateCityWiseSection from "../CityWiseCenters/Sections/UpdateCityWiseSection";
import AddCityWiseSection from "../CityWiseCenters/Sections/AddCityWiseSection";

export default function CitySection() {
  const [record, setRecord] = useState([{}]);
  const [activePage, setActivePage] = useState(1);
  const [search, setSearch] = useState();
  const [addModal, setAddModal] = useState(false);

  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [flag, setFlag] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [data, setData] = useState({});
  const [updateModal, setUpdateModal] = useState(false);
  const [descModal, setDescModal] = useState(false);
  const [descContent, setDescContent] = useState("");
  const debounceValue = useDebounce(search || "", 300);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [editOrderId, setEditOrderId] = useState(null);
  const [selectedData, setSelectedData] = useState({});

  const [selectedId, setSelectedId] = useState("");

  //   ****************************************************** Fetch Roles **********************************************************
  const fetchRoles = async () => {
    try {
      showLoader();
      const res = await getCityDropdown();
      hideLoader();
      if (res.code === 200) {
        setAllRoles(res.data.citywisecenters || []);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    fetchRoles();
  }, []);
  //   ************************************ Fetch Records ***********************************************
  const handleRecords = async (
    page = activePage,
    searchText = debounceValue,
    cityId = selectedCity.value
  ) => {
    try {
      showLoader();
      if (cityId) {
        const res = await getCityWiseSections({
          page,
          search: searchText,
          cityid: cityId,
        });
        hideLoader();
        if (res.code === 200) {
          const { citysections, count } = res.data;
          setRecord(citysections || []);
          setTotal(count || 0);
          setFlag(true);
        } else {
          toast.error(res.message);
          setFlag(false);
        }
      } else {
        toast.error("City ID is mandatory");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    if (flag) {
      handleRecords();
    }
  }, [activePage, limit]);

  const restFilter = () => {
    setSearch("");
    setSelectedId(null);
    setData((prev) => ({ ...prev, moduleName: null }));
    setRecord([]);
    setTotal(0);
  };
  const handleUpdateDisplayOrder = async (sid, newOrder) => {
    try {
      showLoader();
      const res = await cityWiseSectionDisplayOrder({
        id: sid,
        cityid: selectedCity.value,
        displayorder: newOrder,
      });
      hideLoader();
      if (res.code === 200) {
        toast.success("Display order updated successfully");
        setEditOrderId(null);
        handleRecords();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
      hideLoader();
    }
  };
  const handleDelete = async () => {
    showLoader();
    try {
      const res = await cityWiseSectionDelete({
        id: selectedId,
        cityid: selectedCity.value,
      });
      hideLoader();
      if (res.code === 200) {
        toast.success(res.message);
        setDeleteModal(false);
        handleRecords();
      } else {
        setDeleteModal(false);
        handleRecords();
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <form className="" style={{ width: "50%" }}>
                <div className="row w-100 ">
                  <div className={`col-form-label py-0 col-sm-9`}></div>

                  <div className="col-sm-3 "></div>
                </div>
              </form>
              <h4 className="Title">City Section</h4>
            </div>
            <div className="mt-3">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <div style={{ width: "300px" }}>
                  <ReactSelect
                    value={search}
                    onChange={(e) => setSelectedCity(e)}
                    options={allRoles.map((city) => ({
                      value: city.id,
                      label: city.city,
                    }))}
                    className="react-select w-100"
                    placeholder="Select City"
                  />
                </div>

                <Button
                  type="submit"
                  onClick={() => {
                    setActivePage(1);
                    handleRecords();
                  }}
                >
                  Search
                </Button>

                <Button className="refresh_btnn" onClick={restFilter}>
                  <i className="fa fa-refresh"></i>
                </Button>
              {flag && (
                <div style={{ marginLeft: "auto" }}>
                  <Button
                    onClick={() => setAddModal(true)}
                    type="acl"
                    role={850005}
                  >
                    Add Section
                  </Button>
                </div>
              )}
              </div>
            </div>

            {flag && (
              <div className="TableList overflow-auto table-responsive">
                {loader}
                <Table bordered className="table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Section</th>
                      <th>Description</th>
                      <th>Display Order</th>
                      <th style={{ textAlign: "center" }}>H1 Tag</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {record && record.length > 0 ? (
                      record.map(
                        (
                          { id, section, description, ish1tag, displayorder },
                          i
                        ) => (
                          <tr key={i}>
                            <td>{++i + (activePage - 1) * limit}</td>

                            <td>
                              <Tooltip title={section}>
                                <div>{section}</div>
                              </Tooltip>
                            </td>

                            <td className="text-center">
                              <IconButton
                                aria-label="view-description"
                                className="px-2 py-0"
                                onClick={() => {
                                  setDescContent(description || "");
                                  setDescModal(true);
                                }}
                              >
                                <RemoveRedEye style={{ color: "#4971B2" }} />
                              </IconButton>
                            </td>

                            <td className="text-center">
                              <div className="d-flex align-items-center">
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{ width: "80px" }}
                                  value={displayorder}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setRecord((prev) =>
                                      prev.map((item) =>
                                        item.id === id
                                          ? {
                                              ...item,
                                              displayorder: val,
                                              _dirty: true,
                                            }
                                          : item
                                      )
                                    );
                                  }}
                                />
                                <IconButton
                                  aria-label="save-order"
                                  className="ms-2"
                                  disabled={
                                    !record.find((r) => r.id === id)?._dirty
                                  }
                                  onClick={() =>
                                    handleUpdateDisplayOrder(id, displayorder)
                                  }
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    bgcolor: record.find((r) => r.id === id)
                                      ?._dirty
                                      ? "green"
                                      : "grey.400",
                                    "&:hover": {
                                      bgcolor: record.find((r) => r.id === id)
                                        ?._dirty
                                        ? "darkgreen"
                                        : "grey.500",
                                    },
                                  }}
                                >
                                  <CheckIcon
                                    sx={{ color: "white", fontSize: 13 }}
                                  />
                                </IconButton>
                              </div>
                            </td>

                            <td className="text-center">
                              <span
                                className={`badge ${
                                  ish1tag ? "bg-success" : "bg-danger"
                                }`}
                                style={{
                                  fontSize: "12px",
                                  padding: "4px 8px",
                                  minWidth: "40px",
                                }}
                              >
                                {ish1tag ? "Yes" : "No"}
                              </span>
                            </td>

                            <td>
                              <div className="d-flex justify-content-center">
                                <IconButton
                                  aria-label="view"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    setSelectedData({
                                      id,
                                      section,
                                      description,
                                      ish1tag,
                                    });
                                    setUpdateModal(true);
                                  }}
                                  type="acl"
                                  role={850006}
                                  >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                                <IconButton
                                  aria-label="view"
                                  className="px-1 py-0"
                                  onClick={() => {
                                    setDeleteModal(true);
                                    setSelectedId(id);
                                  }}
                                  type="acl"
                                  role={850007}
                                >
                                  <DeleteIcon sx={{ color: "#ff0000" }} />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <NotFound cols={12} />
                    )}
                  </tbody>
                </Table>
              </div>
            )}
            {flag && total > limit ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={(page) => setActivePage(page)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* ***************************** Modal ********************************** */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title={"City Sections"}
        size={"sm"}
        description={"Are you sure want to delete City Section ?"}
        custom={false}
        customizedFooter={
          <Button onClick={handleDelete} {...submitButtonElement}>
            Yes
          </Button>
        }
      />
      <UpdateCityWiseSection
        open={updateModal}
        onClose={() => setUpdateModal(false)}
        data={selectedData}
        cityId={selectedCity?.value}
        citywisecenterListing={handleRecords}
      />
      <ModalBox
        status={descModal}
        onClose={() => setDescModal(false)}
        title={"Section Description"}
        size="md"
        description={<div dangerouslySetInnerHTML={{ __html: descContent }} />}
      />
      <AddCityWiseSection
        open={addModal}
        onClose={() => setAddModal(false)}
        cityId={selectedCity?.value}
        citywisecenterListing={handleRecords}
      />
    </>
  );
}
